export default "__VITE_ASSET__CoSS6JZC__"